import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { createErrorSnackbar, createSuccessSnackbar } from 'components/Snackbar';
import URLS from 'constants/urls';
import braze, { BRAZE_CUSTOM_EVENTS } from 'helpers/braze';
import { reportError } from 'helpers/error-logging';
import { httpClient } from 'helpers/http';
import Segment from 'helpers/segment';

import { downloadCsvResponse } from '../shared/SkuCsvDownload.helpers';

import { skuPayoutReportsMessages as messages } from './SkuPayoutReports.messages';

const FORMAT = 'csv';
const DEFAULT_FILE_NAME = `payout-report.${FORMAT}`;

const useSkuPayoutExport = ({ venueId, payoutId }) => {
  const dispatch = useDispatch();
  const [isExporting, setIsExporting] = useState(false);

  const exportCsv = useCallback(async () => {
    if (venueId == null || payoutId == null || isExporting) return;
    setIsExporting(true);
    try {
      const res = await httpClient.get(URLS.reports.payoutOrdersCsv({ payoutId, venueId }), {
        responseType: 'blob',
      });
      downloadCsvResponse(res, DEFAULT_FILE_NAME);
      dispatch(createSuccessSnackbar(messages.exportStarted));
      Segment.event('Payout Report Exported', { venueId, payoutId, format: FORMAT });
      braze.trackEvent(BRAZE_CUSTOM_EVENTS.PAYOUT_REPORT_EXPORTED);
    } catch (error) {
      reportError(error);
      dispatch(createErrorSnackbar(messages.exportFailed));
    } finally {
      setIsExporting(false);
    }
  }, [venueId, payoutId, isExporting, dispatch]);

  return { exportCsv, isExporting };
};

export default useSkuPayoutExport;
